var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5477_3095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2523 3.70867L15.9336 2.99805H4.08203L4.79266 3.70867L3.05859 5.15648H4.79266L16.8952 5.11492L15.2523 3.70867Z",
    fill: "#F1BC19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 4.31297L3.93313 3.06641L4.62937 3.71953L3.90625 4.31297Z",
    fill: "#D7955F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0942 4.31297L16.0673 3.06641L15.3711 3.71953L16.0942 4.31297Z",
    fill: "#D7955F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1875 4.53125C7.44638 4.53125 7.65625 4.32138 7.65625 4.0625C7.65625 3.80362 7.44638 3.59375 7.1875 3.59375C6.92862 3.59375 6.71875 3.80362 6.71875 4.0625C6.71875 4.32138 6.92862 4.53125 7.1875 4.53125Z",
    fill: "#836F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 4.53125C13.0714 4.53125 13.2812 4.32138 13.2812 4.0625C13.2812 3.80362 13.0714 3.59375 12.8125 3.59375C12.5536 3.59375 12.3438 3.80362 12.3438 4.0625C12.3438 4.32138 12.5536 4.53125 12.8125 4.53125Z",
    fill: "#836F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10352 5.11898L4.73977 3.6543L4.76352 5.19898L3.10352 5.11898Z",
    fill: "#FDE751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9237 5.11898L15.2874 3.6543L15.2637 5.19898L16.9237 5.11898Z",
    fill: "#FDE751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0312 5.15625V15.7812C17.0312 16.4716 16.4716 17.0312 15.7812 17.0312H4.21875C3.52844 17.0312 2.96875 16.4716 2.96875 15.7812V5.15625H17.0312Z",
    fill: "#FDE751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 6C13.1434 6 13.0312 6.11219 13.0312 6.25C13.0312 7.66281 11.6716 8.8125 10 8.8125C8.32844 8.8125 6.96875 7.66281 6.96875 6.25C6.96875 6.11219 6.85656 6 6.71875 6C6.58094 6 6.46875 6.11219 6.46875 6.25C6.46875 7.93875 8.05281 9.3125 10 9.3125C11.9472 9.3125 13.5312 7.93875 13.5312 6.25C13.5312 6.11219 13.4191 6 13.2812 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6563 17.0307L12.8325 14.8432H13.9609C14.2313 14.8432 14.47 14.6701 14.555 14.4135C14.5912 14.3038 14.6284 14.181 14.6597 14.0557C14.7578 13.662 14.4581 13.281 14.0522 13.281H13.145C13.145 13.281 13.0666 12.1063 13.6306 11.2542C13.965 10.7488 14.5525 10.4685 15.1584 10.4685H15.6959C15.8519 10.4685 15.985 10.3545 16.0056 10.1998C16.0744 9.68134 16.0913 8.59353 15.02 8.59353C15.02 8.59353 12.0513 8.43728 10.9575 11.0935C10.9575 11.0935 10.4688 12.031 10.4688 13.281L5.63844 13.2735L8.08437 13.9692L6.67063 14.156L8.4575 14.5307L4.53125 14.8432L10.3731 15.1557L10.1863 16.9626",
    fill: "#2D80D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5477_3095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(2.5 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrp);
export default __webpack_public_path__ + "static/media/vrp.6dc22a694cb50d108e7d45e8724b17a3.svg";
export { ForwardRef as ReactComponent };